import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import { mediaMax, numberSize as breakpoints } from '../../constants/breakpoints'
import FollowMeIframe, { FollowMeIframeRatio, useIntersectionObserver } from '../FollowMeIframe'

interface LiveVideoProps {
  srcVideo?: string
  srcSlido?: string
}

const LiveContent: React.FC<LiveVideoProps> = ({ srcVideo, srcSlido }: LiveVideoProps) => {
  const { isIntersecting, refNode } = useIntersectionObserver()

  const ratio = '56.25'

  const [neverFollow, setNeverFollow] = useState(false)
  useEffect(() => {
    if (window.matchMedia(`(max-width: ${breakpoints.tablet}px)`).matches) {
      setNeverFollow(true)
    }
  }, [isIntersecting])

  const follow = !neverFollow && !isIntersecting
  return (
    <Container className={srcSlido ? 'Slido' : 'onlyVideo'}>
      <ContainerIframeVideo ref={refNode}>
        <FollowMeIframeRatio ratio={ratio} />

        <FollowMeIframe ratio={ratio} follow={follow}>
          {srcVideo && <iframe title="live stream" src={srcVideo} frameBorder="0" allowFullScreen allow="autoplay; fullscreen"/>}
        </FollowMeIframe>
      </ContainerIframeVideo>


      {srcSlido && (
        <ContainerIframeSlido>
          <iframe title="live slido" src={srcSlido} className="slidoFrame" height="100%" width="100%" frameBorder="0" />
        </ContainerIframeSlido>
      )}
    </Container>
  )
}

export default LiveContent


const Container = styled.div`
  display: flex;
  border: 4px solid black;
  border-radius:3px;
  width: ${({ className }) => (className == 'Slido' ? '80vw' : '65vw')};
  flex-direction:row;
  justify-content:center;

  
  @media ${mediaMax.tablet} {
    width: 100%;

    flex-direction: column;
    justify-content: flex-start;
  }
`

export const ContainerIframeVideo = styled.div`
  width: 100%;
  position: relative;
`

export const ContainerIframeSlido = styled.div`
  width: 50%;
  max-width: 400px;
  position: relative;
  // margin-left: 1.66667vw;
  @media ${mediaMax.tablet} {
    width: 100%;
    //margin-top: 20px;
    max-width: 100%;
    height: 40vh;
  }
`
